import React from "react";
import { BrowserRouter, Route , Routes} from "react-router-dom";
import Home from "./components/Home";
import ThankYou from "./components/testimonial-form/ThankYou";


function App() {
  // State variable to track form submission status


  // Function to handle form submission
  const handleFormSubmit = () => {
    // Your form submission logic here...
    // If the form is successfully submitted, setFormSubmitted(true);
    // If there's an error or validation fails, do not setFormSubmitted(true);
    // You can use setFormSubmitted(true); where you handle the form submission.
  };

  return (
    <div className="App">
  
  
      <BrowserRouter basename="/lp/vendor-management-software">
     <Routes>
          <Route index element={<Home />} />
          <Route path="/Thankyou" element={<ThankYou />}/>
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;